import React from "react";
import { message, Typography, Spin } from "antd";
import { NotesCard, EmptyCard } from "../../component";
import { useNavigate } from "react-router-dom";
import "./Notes.less";
import { useGetStudentBatchesQuery } from "../../redux/services/batches";
import { useSelector } from "react-redux";
import { CentreLogo } from "../../assets/images";
import { ROUTE_NOTES_MATERIAL } from "../../constant/routes";

const { Title } = Typography;

const Notes = () => {
  const { student_id } = useSelector((state) => state.auth);
  const {
    data: notes,
    error: notesError,
    isLoading: notesLoading,
  } = useGetStudentBatchesQuery(student_id);
  const navigate = useNavigate();

  const handleCardClick = (coaching_id) => {
    navigate(ROUTE_NOTES_MATERIAL.replace(":coaching_id", coaching_id));
  };

  React.useEffect(() => {
    if (notesError) {
      message.error("Failed to fetch notes. Please try again later.");
    }
  }, [notesError]);

  return (
    <div className='notes-container'>
      <div className='classes-notes'>
        <Title className='title'>Enrolled Classes</Title>

        {/* Content */}
        <Spin spinning={notesLoading}>
          {notes && notes?.data?.length > 0 ? (
            notes?.data?.map((note) => (
              <NotesCard
                key={note.coaching_id}
                coachingName={note.coaching_name}
                subject={note.subjects}
                batch={note.batch_name || "2025-26"}
                coachingLogo={note.coaching_logo || CentreLogo}
                onClick={() => handleCardClick(note.coaching_id)}
              />
            ))
          ) : (
            <EmptyCard text='No notes found' />
          )}
        </Spin>
      </div>
    </div>
  );
};

export default Notes;
